<!-- 
/**
 * Alerts component.
 * 
 * @since 2.0.0
 * @author Fahri Rusliyadi <fahri.rusliyadi@gmail.com>
 */
-->

<template>
    <div v-if="alerts.length" class="alerts fixed-top float-right m-3">
        <div v-for="(alert, index) in alerts" v-bind:key="index" v-bind:class="[`alert-${alert.type}`]" class="alert alert-dismissible fade show" role="alert">
            <div v-html="alert.message"></div>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        /**
         * Properties.
         * 
         * @since 2.0.0
         */
        data: () => ({
            alerts: []
        }),

        /**
         * Methods.
         * 
         * @since 2.0.0
         */
        methods: {
            /**
             * Add an alert.
             * 
             * @since 2.0.0
             * @param {String} message - The message.
             * @param {type} info - Bootstrap alert contextual class.
             */
            add: function(message, type = 'info') {
                this.alerts.push({
                    message: message,
                    type: type
                });

                // Auto remove after 60 seconds.
                setTimeout(() => this.alerts.shift(), 60 * 1000);
            }
        }
    }
</script>

<style scoped>
    .alerts {
        left: auto;
    }
</style>
